import { Country, LocationService } from '@openeducation/oe-rn-services';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import { useEnvironmentContext } from '../environment/environment.provider';

export function useLocationCountriesService() {
  const { environment } = useEnvironmentContext();
  const { t } = useTranslation();

  const { data, isLoading, isError, refetch } = useQuery<Country[]>(
    'locationCountriesService',
    () => fetchCountries()
  );

  const removeIntLocationAndTranslateNames = useCallback(
    (data: Country[]): Country[] => {
      const result = data.filter(
        (location: { isoCode: string }) => location.isoCode !== 'xx'
      );
      return result.map((country) => ({
        ...country,
        countryName: t(`country.${country.isoCode}`),
      }));
    },
    [t]
  );

  const fetchCountries = useCallback(async (): Promise<Country[]> => {
    const data = await LocationService.getCountries(environment);
    if (!data) {
      return [];
    }

    return data;
  }, [environment]);

  const translatedData = useMemo(() => {
    if (!data) {
      return [];
    }

    return removeIntLocationAndTranslateNames(data);
  }, [data, removeIntLocationAndTranslateNames]);

  return {
    data,
    translatedData,
    isError,
    isLoading,
    refetch,
    fetchCountries,
  };
}
